import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
export default function DModalBody({ children, className, style, }) {
    return (_jsx("div", { className: classNames('modal-body', className), style: style, children: children }));
}
//# sourceMappingURL=DModalBody.js.map